import type { ReactElement, ReactNode } from "react";
import { palette, space } from "@ux/tokens";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface EmptyStateProps {
    readonly icon?: ReactNode;
    readonly title: string;
    readonly description?: string;
    readonly action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps): ReactElement {
    return (
        <Stack
            direction="column"
            gap={3}
            align="center"
            justify="center"
            grow
            style={{ padding: space[7], textAlign: "center", color: palette.fgMuted }}
        >
            {icon !== undefined ? (
                <div style={{ color: palette.fgSubtle }}>{icon}</div>
            ) : null}
            <Text role="heading">{title}</Text>
            {description !== undefined ? <Text role="muted">{description}</Text> : null}
            {action !== undefined ? <div>{action}</div> : null}
        </Stack>
    );
}
